<template lang="pug">
  .component-create-packet-entity-button
    ModalReveal(ref="packetModal" :key="key" @input="closeInput")
      slot(slot ="trigger")
        a.fa-stack.fa-lg
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
      .body
        h2 {{title}}
        .row
          .columns.large-4
            label Name
            input(type='text' v-model='body.name')
            label Amount
            input(type="number" v-model="body.amount")
          .columns.large-8
            label Description
              textarea(v-model="body.description" rows="6")
        .row
          //.columns
          //  label Amount
          //    input(type="number" v-model="body.amount")
          .columns.large-3
            label Minutes
            input(type="number" v-model="body.minutes")
          .columns.large-3
            label Distance
            input(type="number" v-model="body.distance")
          .columns.large-3
            label Duration
            input(type="number" v-model="body.duration")
          .columns.large-3
            label Max Uses
            input(type="number" v-model="body.max_uses")
          .columns.large-3
            label Status
            select(v-model="body.status")
              option(:value = "body.status") {{body.status}}
              option(value = "AVAILABLE" ) AVAILABLE
              option(value = "UNAVAILABLE") UNAVAILABLE
        .row.columns.m-2(slot="footer")
        ActionButton(:action="save") Save
</template>

<script>
import ModalReveal from "../../../foundation/ModalReveal";
import ActionButton from "../../ActionButton";
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";
export default {
  name: "PacketModal",
  components: {
    ModalReveal,
    ActionButton
  },
  data() {
    return {
      body:{
        name: null,
        description: null,
        amount:null,
        minutes:null,
        distance:null,
        duration:null,
        max_uses:null,
        status:null
      },
      key:0,
    }

  },
  created() {
    if (this.packet) { console.log(this.packet)
      Object.assign(this.body, this.packet)
    }
  },

  methods: {
    closeInput(event) {
      if(!event) {
        this.key++
      }
    },
    save() {
      if (this.packet) {
        return this.edit()
      }
      return KeplerBackofficeSdk.packets.make(this.body, (data) => {
        MaggieHelper.notification('New packet added ', 'id: '+ data.id)
        this.$emit('itemUpdated', 'added')
        this.key++
        this.body = {
          name: null,
          description: null,
          amount:null,
          minutes:null,
          distance:null,
          duration:null,
          max_uses:null
        }
        this.$refs.packetModal.close()

      })
    },
    edit() {
      return KeplerBackofficeSdk.packets.select(this.body).edit(this.body, (data) => {
        MaggieHelper.notification('Updated packet ', 'id:' + data.id)
        this.$emit('itemUpdated','added')
        this.key++
        this.$refs.packetModal.close()
      })
    }
  },
  props: ['packet','title']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketModal.vue?12345fec